import { render, staticRenderFns } from "./table82.vue?vue&type=template&id=319cdf87&scoped=true&"
import script from "./table82.vue?vue&type=script&lang=js&"
export * from "./table82.vue?vue&type=script&lang=js&"
import style0 from "./table82.vue?vue&type=style&index=0&id=319cdf87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319cdf87",
  null
  
)

export default component.exports